import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Grid,
  MenuItem,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { validationFromSchema } from "../util";
import { $Project, Project } from "../_generated";

export type ProjectExtended = Project & {
  default_aws_region?: string;
  default_aws_key?: string;
  default_aws_secret?: string;
  use_dggr_domain?: string;
  acm_certificate_arn?: string;
  acm_certificate_arn_virginia?: string;
  r53_zone_id?: string;
};

export function OwnProjectEditDialog(props: {
  open: boolean;
  project?: ProjectExtended;
  onCancel: () => any;
  onSubmit: (data: Project) => any;
}) {
  const { register, handleSubmit, errors, control } = useForm();
  return (
    <Dialog open={props.open}>
      <form
        onSubmit={handleSubmit((data: any) =>
          props.onSubmit({ ...props.project, ...data, is_paas: false })
        )}
      >
        <DialogTitle>New Project</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                autoFocus
                required
                inputRef={register(
                  validationFromSchema($Project.properties.name)
                )}
                label="Name"
                name="alias"
                defaultValue={props.project?.name ?? ""}
                error={errors.name !== undefined}
                helperText={errors.name?.message}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                type="password"
                label="AWS key"
                name="default_aws_key"
                fullWidth
                inputRef={register}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                type="password"
                label="AWS secret"
                name="default_aws_secret"
                fullWidth
                inputRef={register}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="default_aws_region"
                defaultValue="us-east-1"
                render={({ onChange, value, ref }) => (
                  <TextField
                    variant="outlined"
                    select
                    label="Default region"
                    value={value}
                    onChange={onChange}
                    inputRef={ref}
                    fullWidth
                  >
                    {awsRegions.map((region) => (
                      <MenuItem value={region} key={region}>
                        {region}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    name="use_dggr_domain"
                    defaultChecked
                    inputRef={register}
                  />
                }
                label="Use *.dggr.app subdomain"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">{props.project ? "Save" : "Create"}</Button>
          <Button onClick={props.onCancel}>Cancel</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export function PaasProjectEditDialog(props: {
  open: boolean;
  project?: ProjectExtended;
  onCancel: () => any;
  onSubmit: (data: Project) => any;
}) {
  const { register, handleSubmit, errors } = useForm();
  return (
    <Dialog open={props.open}>
      <form
        onSubmit={handleSubmit((data: any) =>
          props.onSubmit({ ...props.project, ...data, is_paas: true })
        )}
      >
        <DialogTitle>New Project</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                autoFocus
                required
                inputRef={register(
                  validationFromSchema($Project.properties.name)
                )}
                label="Name"
                name="alias"
                defaultValue={props.project?.name ?? ""}
                error={errors.name !== undefined}
                helperText={errors.name?.message}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">{props.project ? "Save" : "Create"}</Button>
          <Button onClick={props.onCancel}>Cancel</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

//TODO extract together with the similar list in EnvironmentEditDialog
const awsRegions = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "af-south-1",
  "ap-east-1",
  "ap-south-1",
  "ap-northeast-3",
  "ap-northeast-2",
  "ap-northeast-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ca-central-1",
  "cn-north-1",
  "cn-northwest-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "eu-north-1",
  "eu-south-1",
  "me-south-1",
  "sa-east-1",
  "us-gov-east-1",
  "us-gov-west-1",
];
